<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="企业品牌">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.name" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="联系电话">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.mobile" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="招牌名称">
                <a-input
                  @keyup.enter="handleQuery"
                  v-model="queryParam.referredName"
                  placeholder="请输入"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="企业品牌编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template> -->
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="信用代码">
                  <a-input v-model="queryParam.socialCreditCode" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template> -->
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    @keyup.enter="handleQuery"
                    placeholder="请选择"
                    v-model="queryParam.status"
                    style="width: 100%"
                    allow-clear
                  >
                    <a-select-option :value="0"> 正常 </a-select-option>
                    <a-select-option :value="1"> 冻结 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <!-- <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="企业品牌类型">
                    <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                      <a-select-option :value="1"> 厂商 </a-select-option>
                      <a-select-option :value="2"> 经销商 </a-select-option>
                      <a-select-option :value="3"> 分经销商 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </template> -->
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="营业状态">
                  <a-select placeholder="请选择" v-model="queryParam.tradeStatus" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 营业中 </a-select-option>
                    <a-select-option :value="10"> 维修升级中 </a-select-option>
                    <a-select-option :value="60"> 暂停营业 </a-select-option>
                    <a-select-option :value="70"> 隐藏 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template> -->
            <template v-if="advanced">
              <a-col :md="12" :sm="24">
                <a-form-item label="省市区">
                  <v-distpicker
                    :province="queryParam.province"
                    :city="queryParam.city"
                    :area="queryParam.area"
                    @province="onChangeProvince"
                    @city="onChangeCity"
                    @area="onChangeArea"
                  >
                  </v-distpicker>
                </a-form-item>
              </a-col>
            </template>
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="省">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.province" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="市">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.city" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="区">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.area" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template> -->
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker
                    v-model="value"
                    format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:tenant:add']">
          新增
        </a-button>
        <!-- <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['system:tenant:edit']"
        >
          修改
        </a-button> -->
        <!-- <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:post:remove']">
          <a-icon type="delete" />冻结
        </a-button> -->
        <!-- <a-button
          type="primary"
          @click="handleExport"
          :disabled="queryParam.createBeginTime && queryParam.createEndTime ? fasle : true"
          v-hasPermi="['system:tenant:export']"
        >
          导出
        </a-button> -->
        <!-- <a-button type="primary" @click="handleUpload" v-hasPermi="['system:tenant:export']"> 批量导入 </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <UploadAdd ref="uploadAdd" @ok="getList"></UploadAdd>
      <!-- 增加修改 -->
      <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" :role="1" />
      <!-- 设置vr 方案 -->
      <vrForm ref="vrForm"></vrForm>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="name" slot-scope="text, record">
          <a-tooltip :title="record.name" placement="topLeft">
            <span>{{ record.name }}</span>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <!-- <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" /> -->
          {{ record.status ? '冻结' : '正常' }}
        </span>
        <span slot="regionCount" slot-scope="text, record">
          <a-button type="link" size="large" @click="handleLook(record, 2, 'system:qu:one')">
            {{ record.statResult.regionCount }}
          </a-button>
        </span>
        <span slot="tenantCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:qu:one')">
          <a-button type="link" size="large">
            {{ record.statResult.tenantCount }}
          </a-button>
        </span>
        <span slot="waterCount" slot-scope="text, record" @click="handleLook(record, 6, 'system:shui:one')">
          <a-button type="link" size="large" v-if="record.statResult">
            {{ record.statResult.waterCount }}
          </a-button>
        </span>
        <span slot="examinerCount" slot-scope="text, record" @click="handleLook(record, 5, 'system:yan:one')">
          <a-button type="link" size="large" v-if="record.statResult">
            {{ record.statResult.examinerCount }}
          </a-button>
        </span>
        <span slot="devCount" slot-scope="text, record" @click="handleLook(record, 4, 'system:she:one')">
          <a-button type="link" size="large" v-if="record.statResult">
            {{ record.statResult.devCount }}
          </a-button>
        </span>
        <span slot="orderCount" slot-scope="text, record" @click="handleLook(record, 8, 'system:ding:one')">
          <a-button type="link" size="large" v-if="record.statResult">
            {{ record.statResult.orderCount }}
          </a-button>
        </span>
        <span slot="smsBalance" slot-scope="text, record" @click="handleLook(record, 7, 'system:ding:one')">
          <a-button type="link" size="large">
            {{ record.smsBalance }}
          </a-button>
        </span>
        <span slot="type" slot-scope="text, record">
          {{ record.type == 1 ? '厂商' : '经销商' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:tenant:edit']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['system:tenant:frozen']" />
          <a-dropdown v-hasPermi="['system:tenant:query', 'system:tenant:frozen']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['system:tenant:query']">
                <a @click="handleDetail(record)" v-hasPermi="['system:tenant:query']"> 详情 </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['upkeep:service:add', 'upkeep:category:tenant:list']">
                <a
                  @click="$refs.repairConfig.init(record)"
                  v-hasPermi="['upkeep:service:add', 'upkeep:category:tenant:list']"
                >
                  维修配置</a
                >
              </a-menu-item>
              <a-menu-item v-hasPermi="['system:tenant:query']">
                <a @click="handleDefault(record)" v-hasPermi="['system:tenant:query']"> 设置默认清单</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['system:tenant:query']">
                <a @click="handleOrder(record)" v-hasPermi="['system:tenant:query']"> 设置订单详情</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['10b98637049fb72c3493a8f4b983d745d:0:d']">
                <a @click="$refs.vrForm.handleUpdate(record)" v-hasPermi="['10b98637049fb72c3493a8f4b983d745d:0:d']">
                  设置VR方案</a
                >
              </a-menu-item>
              <a-menu-item v-hasPermi="['system:sms:add']">
                <a @click="handleME(record)" v-hasPermi="['system:sms:add']"> 短信充值 </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['system:tenant:query']">
                <a @click="handleDelete(record)" v-hasPermi="['system:tenant:frozen']">
                  {{ record.status == 0 ? '冻结' : '恢复' }}</a
                >
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 详情 -->
    <Detail ref="Detail" @backDate="getList"></Detail>
    <defaultDate ref="defaultDate"></defaultDate>
    <defaultChange ref="defaultChange"></defaultChange>
    <defaultOrder ref="defaultOrder"></defaultOrder>
    <SmsForm ref="SmsForm" @ok="getList"></SmsForm>
    <repair-config ref="repairConfig" />
    <!-- 批量导入 -->
    <!-- <a-modal v-model="visible" title="Basic Modal" @ok="handleOk">
      <p>Some contents...</p>
      <p>Some contents...</p>
      <p>Some contents...</p>
    </a-modal> -->
  </page-header-wrapper>
</template>
<script>
import { listTenant, frozenTenant } from '@/api/system/tenant'
import CreateForm from './modules/CreateForm'
import vrForm from './modules/vrForm'
import UploadAdd from './modules/uploadAdd'
// import Detail from './detail'
import defaultDate from './defaultDate'
import defaultChange from './defaultchang'
import defaultOrder from './defaultOrder'
import SmsForm from '../../pressure/sms/modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
import RepairConfig from './modules/RepairConfig'
export default {
  name: 'Post',
  components: {
    CreateForm,
    Detail: () => import('./detail.vue'), // 正确引用自身
    UploadAdd,
    defaultDate,
    defaultChange,
    defaultOrder,
    SmsForm,
    vrForm,
    RepairConfig,
  },
  prop: ['type'],
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      value: [],
      visible: true,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        type: 1,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '企业品牌',
          dataIndex: 'name',
          width: '10%',
          align: 'center',
          // ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
          width: '105px',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '联系人',
          dataIndex: 'contacts',
          ellipsis: true,
          width: '80px',
          align: 'center',
        },
        {
          title: '区域',
          dataIndex: 'statResult.regionCount',
          width: '60px',
          scopedSlots: { customRender: 'regionCount' },
          align: 'center',
        },
        {
          title: '经销商',
          dataIndex: 'statResult.tenantCount',
          width: '65px',
          scopedSlots: { customRender: 'tenantCount' },
          align: 'center',
        },
        // {
        //   title: '分销商数',
        //   dataIndex: 'referredName3',
        //   align: 'center',
        // },
        {
          title: '设备',
          dataIndex: 'devCount',
          width: '60px',
          scopedSlots: { customRender: 'devCount' },
          align: 'center',
        },
        {
          title: '验收员',
          width: '65px',
          dataIndex: 'examinerCount',
          scopedSlots: { customRender: 'examinerCount' },
          align: 'center',
        },
        {
          title: '水工',
          width: '65px',
          dataIndex: 'waterCount',
          scopedSlots: { customRender: 'waterCount' },
          align: 'center',
        },
        {
          title: '订单',
          dataIndex: 'orderCount',
          width: '65px',
          scopedSlots: { customRender: 'orderCount' },
          align: 'center',
        },
        {
          title: '短信余额',
          width: '80px',
          dataIndex: 'smsBalance',
          scopedSlots: { customRender: 'smsBalance' },
          align: 'center',
        },
        {
          title: '短信',
          width: '60px',
          dataIndex: 'smsUse',
          align: 'center',
        },
        // {
        //   title: '企业品牌类型',
        //   dataIndex: 'type',
        //   scopedSlots: { customRender: 'type' },
        //   align: 'center',
        // },
        // {
        //   title: '信用代码',
        //   dataIndex: 'socialCreditCode',
        //   align: 'center',
        // },
        // {
        //   title: '客服电话',
        //   dataIndex: 'customerMoblie',
        //   align: 'center',
        // },
        {
          title: '状态',
          dataIndex: 'status',
          width: '60px',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        // {
        //   title: '营业状态',
        //   dataIndex: 'tradeStatus',
        //   scopedSlots: { customRender: 'tradeStatus' },
        //   align: 'center',
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          // ellipsis: true,
          align: 'center',
          width: '90px',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '120px',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    console.log(this.type, 'typetypetypetype')
    this.getList()
  },
  computed: {
    hasPermission() {
      return (permission) => {
        console.log(this.userType, '测试type====')
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    /** 查询部门列表 */
    getList() {
      this.loading = true
      listTenant(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleME(row) {
      this.id = row.id
      this.$refs.SmsForm.handleAdd(row.id)
    },
    // 点击批量添加企业品牌
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(1)
      })
    },
    // 点击展示不同的页面信息
    handleLook(e, index, name) {
      if (!this.hasPermission(name)) return this.$message.error('暂无权限查看')
      this.$nextTick(() => {
        this.$refs.Detail.init(e, index)
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
      if (e.length) {
        this.queryParam.createBeginTime = moment(e[0]).format('YYYY-MM-DD') + ' ' + '00:00:00'
        this.queryParam.createEndTime = moment(e[1]).format('YYYY-MM-DD') + ' ' + '23:59:59'
      } else {
        this.queryParam.createBeginTime = ''
        this.queryParam.createEndTime = ''
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        type: 1,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 选择省
    onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.queryParam.province = e.value
      } else {
        this.queryParam.province = ''
      }
    },
    // 选择市
    onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
      }
    },
    // 选择区
    onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      console.log(postIds, 'postIdspostIds')
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      const text = row.status === 0 ? '是否确认冻结此用户' : '是否确认恢复此用户'
      this.$confirm({
        title: text,
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() {},
      })
    },
    // 点击跳转详情
    handleDetail(record) {
      this.$nextTick(() => {
        this.$refs.Detail.init(record, 1)
      })
    },
    // 点击展开默认选项
    handleDefault(record) {
      this.$nextTick(() => {
        this.$refs.defaultDate.init(record)
      })
    },
    // 点击场景设置
    handleChangjing(record) {
      this.$nextTick(() => {
        this.$refs.defaultChange.init(record)
      })
    },
    handleOrder(record) {
      this.$nextTick(() => {
        this.$refs.defaultOrder.init(record)
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/tenant/export',
            {
              ...that.queryParam,
            },
            `企业品牌_${moment().format('YYYY-MM-DD')}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
